import Axios from 'axios'
import {vatUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_vats (context) {
    Axios.get(vatUrls.getAllVats).then(function (response) {
      context.commit('GET_ALL_VATS', response.data)
    })
  },
  get_vats (context, publicId) {
    Axios.get(vatUrls.getVats + publicId).then(function (response) {
      context.commit('GET_VATS', response.data)
    })
  },
  get_deleted_vats (context) {
    Axios.get(vatUrls.getDeletedVat).then(function (response) {
      context.commit('GET_DELETED_VATS', response.data)
    })
  },
  get_vat (context, publicId) {
    Axios.get(vatUrls.getVat + publicId).then(function (response) {
      context.commit('GET_VAT', response.data)
    })
  },
  get_current_vat (context, publicId) {
    Axios.get(vatUrls.getCurrentVat + publicId).then(function (response) {
      context.commit('GET_VAT', response.data)
    })
  },
  post_vat (context, data) {
    Axios.post(vatUrls.postVat, data).then(function () {
      context.dispatch('get_all_vats')
      router.push({
        name: 'VatHistory'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_vat (context, data) {
    Axios.post(vatUrls.postVat, data).then(function () {
      context.dispatch('get_all_vats')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_vat (context, publicId) {
    Axios.delete(vatUrls.deleteVat + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_VATS', response.data)
      router.push({
        name: 'Module.DeletedVats'
      })
    })
  },
  restoreVat (context, publicId) {
    Axios.get(vatUrls.restoreVat + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_VATS', response.data)
      router.push({
        name: 'Module.Vats'
      })
    })
  }
}
